export function deepLinkHandler(postLoginScreen: string) {
  //   TODO: Deep links can be added at a later date

  //   const searchParams = new URLSearchParams(postLoginScreen || '');
  //   const type = searchParams.get('type');
  //   const id = searchParams.get('id');
  //   const accountId = searchParams.get('account_id');
  //   let path = '';

  //   switch (type) {
  //     case 'depositCheck':
  //       path = ROUTES.CHECK_DEPOSIT;
  //       break;
  //     case 'taxDocuments':
  //       path = `${ROUTES.INTERNAL_ACCOUNT_DETAILS}/${id}${ROUTES.TAX_DOCUMENTS}`;
  //       break;
  //     case 'transaction':
  //       path = `${ROUTES.INTERNAL_ACCOUNT_DETAILS}/${accountId}${ROUTES.TRANSACTION_DETAILS}/${id}`;
  //       break;
  //     case 'thirdPartyWireRecipientRequest':
  //       path = `${ROUTES.ADVISOR_WIRE_RECIPIENT_REQUEST}/${id}`;
  //       break;
  //     case 'transactionRequest':
  //       path = `${ROUTES.ADVISOR_TRANSACTION_REQUEST}/${id}`;
  //       break;
  //     case 'externalAccount':
  //       path = `${ROUTES.EXTERNAL_ACCOUNT_DETAILS}/${id}`;
  //       break;
  //   }

  //   return path;

  return postLoginScreen;
}
